var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed } from 'mobx';
import _ from 'lodash';
import Model from '../models/Model';
import Filter from './filters/Filter';
import SortModel from "../models/SortModel";
/**
 *
 */
var Collection = /** @class */ (function () {
    /**
     *
     * @param modelType
     */
    function Collection(modelType) {
        if (modelType === void 0) { modelType = Model; }
        this.list = [];
        this.filter = new Filter();
        this.sort = new SortModel();
        this.modelType = modelType;
    }
    Object.defineProperty(Collection.prototype, "filteredAndSorted", {
        /**
         *
         * @return {*}
         */
        get: function () {
            return this.applySort(this.filtered);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "sorted", {
        /**
         *
         * @return {*}
         */
        get: function () {
            return this.applySort(this.list);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collection.prototype, "filtered", {
        /**
         *
         */
        get: function () {
            var _this = this;
            if (this.filter) {
                return this.list.filter(function (object) {
                    return _this.filter.apply(object);
                });
            }
            return this.list;
        },
        enumerable: false,
        configurable: true
    });
    /**
     *
     * @param fieldName
     * @param value
     * @return {*}
     */
    Collection.prototype.find = function (fieldName, value) {
        return this.list.find(function (model) {
            return model[fieldName] === value;
        });
    };
    /**
     *
     * @param id
     * @return {*}
     */
    Collection.prototype.findById = function (id) {
        return this.list.find(function (model) {
            return model.id === id;
        });
    };
    /**
     *
     * @param array
     */
    Collection.prototype.addAll = function (array) {
        var _this = this;
        var models = [];
        array.forEach(function (data) {
            var model = data;
            if (!(data instanceof _this.modelType)) {
                try {
                    model = new _this.modelType(data);
                }
                catch (exception) {
                    console.log('exception', exception);
                }
            }
            models.push(model);
        });
        this.list = this.list.concat(models);
    };
    /**
     *
     * @param data
     * @param forceUpdate
     */
    Collection.prototype.add = function (data, forceUpdate) {
        if (forceUpdate === void 0) { forceUpdate = true; }
        var model;
        if (!(data instanceof this.modelType)) {
            model = new this.modelType(data);
        }
        else {
            model = data;
        }
        this.list.push(model);
        if (forceUpdate) {
            this.update();
        }
    };
    /**
     *
     * @param data
     */
    Collection.prototype.remove = function (data) {
        _.remove(this.list, function (item) {
            return data === item;
        });
        // Force trigger mobx event
        this.list = this.list.concat([]);
    };
    /**
     *
     */
    Collection.prototype.reset = function (includeFilters) {
        if (includeFilters === void 0) { includeFilters = true; }
        this.list = [];
        if (includeFilters) {
            this.filter.resetAllFilters();
        }
    };
    /**
     *
     */
    Collection.prototype.update = function () {
        this.list = this.list.concat([]);
    };
    /**
     *
     * @return {*[]|Array}
     * @private
     */
    Collection.prototype.applyFilter = function () {
        var _this = this;
        if (this.filter) {
            return this.list.filter(function (object) {
                return _this.filter.apply(object);
            });
        }
        return this.list;
    };
    /**
     *
     * @private
     */
    Collection.prototype.applySort = function (items) {
        return items;
    };
    __decorate([
        observable
    ], Collection.prototype, "list", void 0);
    __decorate([
        observable
    ], Collection.prototype, "filter", void 0);
    __decorate([
        observable
    ], Collection.prototype, "sort", void 0);
    __decorate([
        computed
    ], Collection.prototype, "filteredAndSorted", null);
    __decorate([
        computed
    ], Collection.prototype, "sorted", null);
    __decorate([
        computed
    ], Collection.prototype, "filtered", null);
    return Collection;
}());
export default Collection;
